import { FormikProvider } from 'formik';
import styled from '@emotion/styled';

import { getFormBySchema } from '../utils/get-form-by-schema';

import { FormSchema, IUpdateFormikReturn } from '../types';

const StyledFieldsContainer = styled('div')(({ theme }: { theme?: any }) => ({
  maxWidth: '504px',
}));

interface Props extends Omit<IUpdateFormikReturn<any>, 'disableToggle' | 'isLoading'> {
  schema: FormSchema;
};

export const AdminProductFields = ({ schema, formik, disabled }: Props) => (
  <FormikProvider value={formik}>
    <StyledFieldsContainer>
      {getFormBySchema(schema, formik, disabled)}
    </StyledFieldsContainer>
  </FormikProvider>
);
